const links = [
    {
      name: 'About',
      label: {
        es: 'Quienes Somos',
        en: 'About Us'
      }
    },
    {
      name: 'CapitalInvestment',
      label: {
        es: 'Inversión de Capital',
        en: 'Capital Investment'
      }
    },
    {
      name: 'PartnersForGrowth',
      label: {
        es: 'Socios para Crecer',
        en: 'Partners for growth'
      }
    },
    {
      name: 'Trustworthiness',
      label: {
        es: 'Confiabilidad',
        en: 'Trustworthiness'
      }
    },
    {
      name: 'BetterPerformance',
      label: {
        es: 'Mejores Rendimientos',
        en: 'Better Performance'
      }
    },
    {
      name: 'Investments',
      label: {
        es: 'Inversiones',
        en: 'Investments'
      }
    },
    /*{
      name: 'WhyUs',
      label: {
        es: 'Beneficios',
        en: 'Why Us'
      }
    },*/    
    {
      name: 'Securities',
      label: {
        es: 'Emisiones',
        en: 'Securities'
      }
    },
    {
      name: 'ShareholderRelations',
      label: {
        es: 'Información para Accionistas',
        en: 'Shareholder Relations'
      },
      children: [
        {
          name: 'StockQuote',
          label: {
            es: 'Cotización de Acción',
            en: 'Stock Quote'
          }
        },
        {
          name: 'SunavalFilings',
          label: {
            es: 'Reportes',
            en: 'Reports'
          }
        },
      ]
    },
    {
      name: 'PressRelease',
      label: {
        es: 'Notas de Prensa',
        en: 'Press Release'
      }
    },
    {
      name: 'Contact',
      label: {
        es: 'Contacto',
        en: 'Contact'
      }
    }
  ]

export default links
